/**
 * Customer Support Contact Information Constants
 */

export const SUPPORT_PHONE_NUMBERS = {
  INDIA: {
    display: '+91 80 4711 0244',
    tel: '+918047110244',
    whatsapp: 'https://wa.me/918047110244',
    fallback: '8047110244', // Without +91 prefix
    hours: {
      anytime: 'Our support team is available to help you at any time.',
    },
  },
  // US: {
  //   display: '+1 213 556 4363',
  //   tel: '+12135564363',
  //   hours: {
  //     weekdays: 'Mon–Fri: 10AM–9PM EST',
  //     weekends: 'Sat–Sun: 10AM–7PM EST',
  //   },
  // },
} as const;

export const SUPPORT_REQUIRED_TOURNAMENT_IDS: number[] = [
  46791, // Master Pride
  46802, // Master Pride Plus
  // 29551, // Duel Batch (IND)
  // 35356, // Duel Batch (USA)
];

